PlantingOptions = App.loadClass 'grower::viewmodels/placement/seed_options/PlantingOptions'
yearUtil = require 'resources/assets/coffee/Core/utils/year'

class exports.PlantingPlanFactory
    create: (field, parent_handler, spp_handler, replace_products) =>
        options =
            company_id: spp_handler.companyID
            crop_id: spp_handler.cropID
            spp_id: spp_handler.sppID
            fsr_id: field.fsr_id
            survey_result_id: parent_handler.loadLayoutPostOptions?.result_id

            sppPlantingPlan: spp_handler.customPlantingPlan
            sppPlanterSubscription: spp_handler.customPlanterSubscription
            sppProductSubscription: spp_handler.customProductSubscription

            calculate_population: spp_handler.calculates_populations
            sppPopulationAdjustment: spp_handler.customPopulationAdjustment

        # population range
        min_pop = spp_handler.getFieldAspectByName(field.id, 'Planting Min Pop')?.value
        max_pop = spp_handler.getFieldAspectByName(field.id, 'Planting Max Pop')?.value

        if min_pop? and max_pop?
            options.min_max_pop =
                min: min_pop
                max: max_pop

        # events/products
        if replace_products
            product = field.hybrid_selection()
            refuge = field.refuge_selection()

            if product? and refuge?
                refugeAspect = spp_handler.getFieldAspectByName(field.id, 'Refuge Configuration')
                refugeApplication = refugeAspect?.option_name?.toLowerCase().split(' ')[0] ? 'strips'

                switch refugeApplication
                    when 'block'
                        # refuge is planted in a separate event
                        events = [
                            { stages: [seed_company: product.seed_companies_id, product: product.id] }
                            { stages: [seed_company: refuge.seed_companies_id, product: refuge.id] }
                        ]
                    when 'adjacent field'
                        # omit refuge altogether
                        events = [
                            { stages: [seed_company: product.seed_companies_id, product: product.id] }
                        ]
                    else
                        # split planter
                        events = [
                            { stages: [
                                { seed_company: product.seed_companies_id, product: product.id }
                                { seed_company: refuge.seed_companies_id, product: refuge.id }
                            ] }
                        ]
            else
                # do this even if no hybrid selected (hybrid is null)
                events = [
                    { stages: [{ seed_company: product?.seed_companies_id, product: product?.id }] }
                ]

            options.events = events

        layer_id = field.planting_plan_id()
        # hax to launch an angular state from a non-angular handler
        if layer_id?
            $(window).trigger 'spp.edit-planting-plan',
                year: spp_handler.year
                field_id: field.id
                layer_id: layer_id
                options: options
        else
            $(window).trigger 'spp.add-planting-plan',
                year: spp_handler.year
                field_id: field.id
                options: options

        return
